import { render, staticRenderFns } from "./DesignDCF.vue?vue&type=template&id=333b021e"
import script from "./DesignDCF.vue?vue&type=script&lang=js"
export * from "./DesignDCF.vue?vue&type=script&lang=js"
import style0 from "./DesignDCF.vue?vue&type=style&index=0&id=333b021e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports